/**
 * Get the list of projects
 */
export function getProjects(state) {
    return state.projects || [];
}
